import { toast } from 'react-toastify';
import { buildConnectorParametersDecryptUrl } from '../../utils/connectorParametersApi';

// Get token from localStorage
const token = localStorage.getItem('token');

export const getFusionOperationCredentialsAndCreateToken = async (connectorId, mcId, masterConnectors) => {
  try {
    console.log('Generating Fusion Operation token for connector:', connectorId);
    
    // Find the Fusion Operation master connector details
    // Prefer canonical mcConnectorType, but allow legacy name variants.
    const fusionOperationConnector = masterConnectors.find(mc => 
      (mc.mcRecId?.toString() === mcId?.toString() || 
       mc.mcId?.toString() === mcId?.toString()) && 
      (
        mc.mcConnectorType?.toUpperCase() === "FUSION_OPERATION" ||
        mc.mcName === "Fusion Operation" ||
        mc.mcName === "FusionOperation"
      )
    );
    
    if (!fusionOperationConnector) {
      throw new Error('Fusion Operation master connector not found');
    }

    // Fetch connector parameters from the API endpoint using connector instance ID (ctd_id)
    const paramResponse = await fetch(buildConnectorParametersDecryptUrl(connectorId), {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (!paramResponse.ok) {
      throw new Error('Failed to fetch connector parameters');
    }
    
    const connectorParams = await paramResponse.json();
    
    // Call the Fusion Operation authorization endpoint using connector instance ID (ctd_id)
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}synctrack/fusion/authorize?mcId=${connectorId}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Fusion Operation authorization error:', errorText);
      throw new Error(`Failed to authorize Fusion Operation: ${response.status}`);
    }

    // Parse the response to get the token
    const tokenData = await response.json();
    console.log('Fusion Operation token response:', tokenData);
    
    // Check if we have a valid token
    if (!tokenData.token) {
      throw new Error('No token received from Fusion Operation API');
    }
    
    toast.success('Fusion Operation token generated successfully');
    
    // Return the token
    return tokenData.token;
  } catch (error) {
    console.error('Error generating Fusion Operation token:', error);
    toast.error(`Failed to generate Fusion Operation token: ${error.message}`);
    throw error;
  }
};

export default {
  getFusionOperationCredentialsAndCreateToken
};